<template>
  <div>
    <MobileMenu/>
    <v-row no-gutters>
      <v-col cols="12">
        <BanersRow/>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <ProductsBlock v-for="(block, index) in productBlocks"
                     :key="index"
                     :block-type="index"
                     :showVideoTile="block.showVideoTile"
                     :color="block.color"
                     :conditions="block.conditions"
      />
    </v-row>
    <v-row>
      <ProductsBlock key="gadgets"
                     blockType="gadgets"
                     color="#0084cc"
                     :conditions="gadgetConditions"
      />
    </v-row>
  </div>
</template>

<script>
import BanersRow from '@/components/Partials/ShopBody/BanersRow.vue';
import ProductsBlock from '@/components/Partials/ShopBody/ProductsBlock.vue';
import Axios from '@/core/Axios';
import MobileMenu from '@/components/Partials/TopBar/MobileMenu.vue';
import store, { state } from '../../../store/index';

export default {
  name: 'ShopBody',
  props: ['showBanners'],
  components: { MobileMenu, ProductsBlock, BanersRow },
  data() {
    return {
      axios: new Axios(),
      productsLists: {},
      config: state.config,
      gadgetConditions: {
        categories: {
          id: {
            operator: '=',
            value: 14,
          },
        },
      },
    };
  },
  mounted() {
    this.getShopConfig();
  },
  computed: {
    productBlocks() {
      if (state.config) {
        return JSON.parse(state.config).shopBodyProductBlocks;
      }
      return null;
    },
  },
  methods: {
    getShopConfig() {
      if (state.config === null) {
        this.axios.makeCall('GET', 'norbit/getshopconfig')
          .then((response) => {
            store.commit('setConfig', response.config);
          });
      }
    },
  },
};
</script>

<style scoped>

</style>
